import { required } from './common'

export default (value) => {
  return !required(value)
}
